export const deleteAssignBadge = (payload: any) => ({
    type: "@saga/DELETE_ASSIGN_BADGE",
    payload
});